module.exports = __webpack_public_path__ + "img/651e8250d1d4f7f66ac4a233735e1dcc.png";